import LanguageActionsEnums from './LanguageActionsEnums'

export const setLanguage = (language) => {
    return (dispatch) => {
        return dispatch({
            type: LanguageActionsEnums.LANGUAGE_SET,
            language: language
        });
    }
};



// WEBPACK FOOTER //
// ./src/store/language/LanguageActions.js